import { cn } from "@/lib/utils";

const sizeClassMap = {
  "16": "size-4",
  "20": "size-5",
} as const;

export const DeletedUserAvatar = ({
  size = "20",
  className,
}: {
  size?: keyof typeof sizeClassMap;
  className?: string;
}) => (
  <span
    aria-label="삭제된 유저"
    className={cn(
      "inline-flex shrink-0 rounded-full bg-line-normal",
      sizeClassMap[size],
      className,
    )}
  />
);
